import * as React from "react";
import PropType from "prop-types";

import * as styles from "./index.module.scss";

import SectionLayout from "../SectionLayout";
import TextWithTitle from "../TextWithTitle";

const ContentText = ({ content, dateContent }) => {
  if (!content) return null;

  return (
    <SectionLayout className={styles.sectionWrapper}>
      {dateContent && <p className={styles.dateOfConditions}>{dateContent}</p>}
      {content.map(({ title, text, image }, index) => (
        <TextWithTitle title={title} text={text} key={index} image={image} />
      ))}
    </SectionLayout>
  );
};

ContentText.propTypes = {
  content: PropType.array,
};

export default ContentText;
